var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "configManager" } }, [
    _vm._v("\n  仅用于测试\n"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }